import { compose } from 'redux';
import { connect } from '../../../../../react-redux';
import makeEditable from '../../../../shared/functionality/makeEditable';
import { DELETED_QUIZ_ENTRY } from '@instructure/quiz-common';
import { clear } from '../../../../../actions/ui';
import { openAddContentModal } from '../../../../../actions/modal';
import { AddContentPopover as AddContentPopoverPresenter } from './presenter';

// only exported for testing - not intended for external use
export function shouldFocus(state, props) {
  var deletedQuizEntry = state.getIn(['ui', DELETED_QUIZ_ENTRY], {});
  var position = props.position,
    stimulusId = props.stimulusId;
  var positionMatches = deletedQuizEntry.position === position;
  var bothInStimulus = deletedQuizEntry.inStimulus && stimulusId !== void 0;
  var neitherInStimulus = !deletedQuizEntry.inStimulus && stimulusId === void 0;
  var stimulusMatches = bothInStimulus || neitherInStimulus;
  var deletedFirst = deletedQuizEntry.position === 1;
  var isFirst = position === 0;
  return positionMatches && stimulusMatches || deletedFirst && isFirst;
}
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    appContainer: state.getIn(['ui', 'appContainer']),
    guid: "add_content_popover".concat(props.stimulusId ? '_stimulus' : '', "_").concat(Math.ceil(props.position)),
    shouldFocus: shouldFocus(state, props)
  };
};
var mapDispatchToProps = {
  openAddContentModal: openAddContentModal,
  clearUi: clear
};
export var AddContentPopover = compose(connect(mapStateToProps, mapDispatchToProps), makeEditable)(AddContentPopoverPresenter);
export default AddContentPopover;